import { CSSProperties } from 'react';

// Statement styles
export const statementStyle = {
  // Statements can contain linechanges
  whiteSpace: 'pre-line',
} as CSSProperties;
